// countryCodeLookup.js
import countries from "./countries-min.json";

export const getCountryCode = (countryName) => {
  if (!countryName) return null;

  // Normalize input for case-insensitive matching
  const normalizedInput = countryName.trim().toLowerCase();

  // Find a country whose 'common' or 'official' name matches exactly
  const found = countries.find((c) => {
    const commonLower = c.name.common?.toLowerCase() ?? "";
    const officialLower = c.name.official?.toLowerCase() ?? "";
    return (
      commonLower === normalizedInput || officialLower === normalizedInput
    );
  });

  // Return the 2-letter country code (cca2) if found
  return found ? found.cca2 : null;
};
